export default __webpack_public_path__ + "static/media/arrow_right_normal_icon.76e7c68d.svg";